import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import api from "../../api/axios";
import { getapiKey, getbaseURL } from "../../api/axios";

const getAuthHeaders = () => {
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  if (!user?.token) {
    throw new Error("Authentication token is missing or invalid");
  }
  return {
    Authorization: `Bearer ${user.token}`,
    Accept: "application/json",
    "Content-Type": "application/json",
  };
};
const getAuthHeadersapiKey = () => {
  return {
    Authorization: `Bearer ${getapiKey()}`,
    Accept: "application/json",
    "Content-Type": "application/json",
  };
};
// Async thunks
export const registerUser = createAsyncThunk("auth/register", async (userData, { rejectWithValue }) => {
  try {
    // const response = await axios.post(`${API_URL}/register`, userData);

    const response = await axios.post(`${getbaseURL()}/users/registration`, userData, {
      headers: getAuthHeadersapiKey(),
    });

    if (response.data.token) {
      localStorage.setItem("user", JSON.stringify(response.data));
    }
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const loginUser = createAsyncThunk("auth/login", async (userData, { rejectWithValue }) => {
  try {
    const response = await api.post(`/agentlogin`, userData);
    if (response.data.token) {
      localStorage.setItem("user", JSON.stringify(response.data));
    }
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const logoutUser = createAsyncThunk("auth/logout", async (_, { rejectWithValue }) => {
  try {
    // Make API call to logout endpoint
    await api.post(`/logout`);
    // Clear local storage
    localStorage.removeItem("user");
    // Return success message or empty object
    return {};
  } catch (error) {
    if (error.response.data.httpStatus === 401 && error.response.data.message === "Unauthenticated") {
      window.location.reload();
    }
    // Even if API logout fails, we still want to clear local storage
    localStorage.removeItem("user");
    return rejectWithValue(error.response?.data || error.message);
  }
});

export const fetchuserdetails = createAsyncThunk("auth/users/details", async (_, { rejectWithValue }) => {
  try {
    const response = await api.post(`/users/details`, { headers: getAuthHeaders() });

    return { data: response.data };
  } catch (error) {
    return rejectWithValue({
      message: error.message || "Failed to fetch user data",
      status: error.response?.status,
      data: error.response?.data,
    });
  }
});
export const fetchagentmarkup = createAsyncThunk("auth/agentmarkup", async (_, { rejectWithValue }) => {
  try {
    const response = await api.post(`/agentmarkup`, { headers: getAuthHeaders() });

    return { data: response.data };
  } catch (error) {
    return rejectWithValue({
      message: error.message || "Failed to fetch user data",
      status: error.response?.status,
      data: error.response?.data,
    });
  }
});
export const fetchfranchiseecomm = createAsyncThunk("auth/franchisee-users/franchisee-commission", async (_, { rejectWithValue }) => {
  try {
    const response = await api.post(`/franchisee-users/franchisee-commission`, { headers: getAuthHeaders() });

    return { data: response.data };
  } catch (error) {
    return rejectWithValue({
      message: error.message || "Failed to fetch user data",
      status: error.response?.status,
      data: error.response?.data,
    });
  }
});
export const DoUpdateaAgentmarkup = createAsyncThunk("auth/addagentmarkup", async (formData, { rejectWithValue }) => {
  try {
    const response = await api.post(`/addagentmarkup`, formData, { headers: getAuthHeaders() });

    return { data: response.data };
  } catch (error) {
    return rejectWithValue({
      message: error.message || "Failed to fetch user data",
      status: error.response?.status,
      data: error.response?.data,
    });
  }
});
export const DoUpdateDetails = createAsyncThunk("auth/users/updatedetails", async (formData, { rejectWithValue }) => {
  try {
    const response = await api.post(`/users/updatedetails`, formData, {
      headers: {
        ...getAuthHeaders(),
        "Content-Type": "multipart/form-data", // Important for file upload
      },
    });

    return { data: response.data };
  } catch (error) {
    return rejectWithValue({
      message: error.message || "Failed to fetch user data",
      status: error.response?.status,
      data: error.response?.data,
    });
  }
});
export const SendOTP = createAsyncThunk("auth/sms/sendotp", async (OTPRequest, { rejectWithValue }) => {
  try {
    const response = await axios.post(`${getbaseURL()}/sms/sendotp`, OTPRequest, { headers: getAuthHeadersapiKey() });

    return { data: response.data };
  } catch (error) {
    return rejectWithValue({
      message: error.message || "Failed to fetch user data",
      status: error.response?.status,
      data: error.response?.data,
    });
  }
});
export const verifyOTP = createAsyncThunk("auth/sms/verifyotp", async (Verify, { rejectWithValue }) => {
  try {
    const response = await axios.post(`${getbaseURL()}/sms/verifyotp`, Verify, { headers: getAuthHeadersapiKey() });

    return { data: response.data };
  } catch (error) {
    return rejectWithValue({
      message: error.message || "Failed to fetch user data",
      status: error.response?.status,
      data: error.response?.data,
    });
  }
});
export const verifyPAN = createAsyncThunk("auth/users/panverify", async (PanVerify, { rejectWithValue }) => {
  try {
    const response = await axios.post(`${getbaseURL()}/users/panverify`, PanVerify, {
      headers: getAuthHeadersapiKey(),
    });

    return { data: response.data };
  } catch (error) {
    return rejectWithValue({
      message: error.message || "Failed to fetch user data",
      status: error.response?.status,
      data: error.response?.data,
    });
  }
});
export const ForgotPassword = createAsyncThunk(
  "auth/customer/forgot-password",
  async (CheckUser, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${getbaseURL()}/customer/forgot-password`, CheckUser, {
        headers: getAuthHeadersapiKey(),
      });

      return { data: response.data };
    } catch (error) {
      return rejectWithValue({
        message: error.message || "Failed to fetch user data",
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);
export const ResetPassword = createAsyncThunk(
  "auth/customer/reset-password",
  async (formDataReset, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${getbaseURL()}/customer/reset-password`, formDataReset, {
        headers: getAuthHeadersapiKey(),
      });

      return { data: response.data };
    } catch (error) {
      return rejectWithValue({
        message: error.message || "Failed to fetch user data",
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);
export const GetStaticContent = createAsyncThunk("auth/cms/static-data", async (pageurl, { rejectWithValue }) => {
  try {
    const response = await axios.post(`${getbaseURL()}/cms/static-data`, pageurl, { headers: getAuthHeadersapiKey() });

    return { data: response.data };
  } catch (error) {
    return rejectWithValue({
      message: error.message || "Failed to fetch user data",
      status: error.response?.status,
      data: error.response?.data,
    });
  }
});

// export const logoutUser = createAsyncThunk('auth/logout', async () => {
//   localStorage.removeItem('user')
// })

const initialState = {
  user: JSON.parse(localStorage.getItem("user")),
  status: "idle",
  logoutstatus: "idle",
  detailsstatus: "idle",
  agentmarkupstatus: "idle",
  franchiseecommstatus: "idle",
  franchiseecomm: null,
  agentmarkup: null,
  details: null,
  UpdateUserstatus: "idle",
  UpdateUserData: null,
  SendOTPstatus: "idle",
  SendOTPData: null,
  VerifyOTPstatus: "idle",
  VerifyData: null,
  VerifyPANstatus: "idle",
  VerifyPANData: null,
  ForgotPasswordstatus: "idle",
  ForgotPasswordData: null,
  ResetPasswordstatus: "idle",
  ResetPasswordData: null,
  error: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(registerUser.pending, (state) => {
        state.status = "loading";
      })
      .addCase(registerUser.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.user = action.payload;
      })
      .addCase(registerUser.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(loginUser.pending, (state) => {
        state.status = "loading";
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.user = action.payload;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(logoutUser.pending, (state, action) => {
        state.logoutstatus = "pendig";
      })
      .addCase(logoutUser.fulfilled, (state) => {
        state.user = null;
        state.logoutstatus = "success";
      })
      .addCase(fetchuserdetails.pending, (state, action) => {
        state.detailsstatus = "pendig";
      })
      .addCase(fetchuserdetails.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.details = data || {};
        state.detailsstatus = "success";
      })
      .addCase(DoUpdateDetails.pending, (state, action) => {
        state.UpdateUserstatus = "pendig";
      })
      .addCase(DoUpdateDetails.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.UpdateUserData = data || {};
        state.UpdateUserstatus = "success";
      })
      .addCase(SendOTP.pending, (state, action) => {
        state.SendOTPstatus = "pendig";
      })
      .addCase(SendOTP.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.SendOTPData = data || {};
        state.SendOTPstatus = "success";
      })
      .addCase(verifyOTP.pending, (state, action) => {
        state.VerifyOTPstatus = "pendig";
      })
      .addCase(verifyOTP.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.VerifyData = data || {};
        state.VerifyOTPstatus = "success";
      })
      .addCase(verifyPAN.pending, (state, action) => {
        state.VerifyPANstatus = "pendig";
      })
      .addCase(verifyPAN.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.VerifyPANData = data || {};
        state.VerifyPANstatus = "success";
      })
      .addCase(ForgotPassword.pending, (state, action) => {
        state.ForgotPasswordstatus = "pendig";
      })
      .addCase(ForgotPassword.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.ForgotPasswordData = data || {};
        state.ForgotPasswordstatus = "success";
      })
      .addCase(ResetPassword.pending, (state, action) => {
        state.ResetPasswordstatus = "pendig";
      })
      .addCase(ResetPassword.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.ResetPasswordData = data || {};
        state.ResetPasswordstatus = "success";
      })
      .addCase(fetchagentmarkup.pending, (state, action) => {
        state.agentmarkupstatus = "pendig";
      })
      .addCase(fetchagentmarkup.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.agentmarkup = data || {};
        state.agentmarkupstatus = "success";
      })
      .addCase(fetchfranchiseecomm.pending, (state, action) => {
        state.franchiseecommstatus = "pendig";
      })
      .addCase(fetchfranchiseecomm.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.franchiseecomm = data || {};
        state.franchiseecommstatus = "success";
      });
  },
});

export const selectCurrentUser = (state) => state.auth.user;
export const selectAuthStatus = (state) => state.auth.status;
export const selectAuthError = (state) => state.auth.error;
export const selectregisterUserr = (state) => state.registerUser.user;

export default authSlice.reducer;
